export default __webpack_public_path__ + "static/media/poland.6b7ae351.svg";